import { useQuery } from "@tanstack/react-query";

import { getMe } from "../api/me";
import { DEFAULT_CURRENCY } from "../utils/money";

/**
 * 店の通貨（`/api/me` の `currency`）。金額を出す画面が `money()` に渡す。
 *
 * `["me"]` クエリは ProductLimitBanner / 各ページと共有するため**追加フェッチは
 * 発生しない**（GatedQueryError と同じ手）。未取得のあいだは既定（JPY）＝
 * 通貨が決まるまで金額を空にすると、読み込みのたびに数字が消えて見える。
 *
 * ⚠️ **発注書の画面では使わない**＝あちらは `draft.currency` が正（同じ値だが、
 * 出力（PDF・CSV・メール）と画面を同じ1つの値から作るほうがずれない）。
 */
export function useCurrency(): string {
  const { data } = useQuery({ queryKey: ["me"], queryFn: getMe });
  return data?.currency || DEFAULT_CURRENCY;
}
